import '~/public/static/css/eurostileLtStd.css'
import '~/public/static/css/normalize.css'
import '~/public/static/css/variables.css'
import '~/public/static/css/style.css'

import React, { useEffect } from 'react'
import Head from 'next/head'
import Renderer from '~/components/Renderer'
import { useStore } from '~/store'
import { Provider } from 'react-redux'
import { getUser } from '~/store/actions/authentication'
import {
  initGA,
  logPageView,
  logComponentView,
} from '~/helpers/google-analytics'
import { hotjar } from 'react-hotjar'
import ScreenProvider from '~/providers/ScreenProvider'
import { queryParams, storage } from '~/helpers'
import routerEvents from '~/router/events'
import {isProduction} from "~/helpers/environment";
import {ClerkProvider} from '@clerk/nextjs'
import { dark } from '@clerk/themes';
function MyApp (props) {
  const store = useStore();

  useEffect(() => {
    if (isProduction) {
      initGA();
      logPageView();
      logComponentView('Component is _app.js');

      hotjar.initialize(1205332, 6)
    }

    if (typeof window !== 'undefined') {
      const params = queryParams()
      if (params.source === 'app' && params.token) {
        storage.setItem('token', params.token)
        console.log("loading user")
        store.dispatch(getUser())
      }

      routerEvents.mount()
    }

    return () => {
      routerEvents.unmount()
    }
  }, [])

  return (
    <>
      <Head>
        <title>GameGlass</title>
        <meta
          name='viewport'
          content='width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no,minimal-ui'
        />
        <link
          href='https://fonts.googleapis.com/css?family=Electrolize'
          rel='stylesheet'
        />
        <link
          href='https://fonts.googleapis.com/css?family=Barlow+Condensed:300,600'
          rel='stylesheet'
        />
        <link
          href='https://fonts.cdnfonts.com/css/proxima-nova-2'
          rel='stylesheet'
        />
        <link
          href='https://bucket.gameglass.gg/fonts/3A6108_0_0.woff2'
          rel='binary/octet-stream'
        />
        <link
          href='https://bucket.gameglass.gg/fonts/3A6108_0_0.eot'
          rel='binary/octet-stream'
        />
        <link
          href='https://bucket.gameglass.gg/fonts/3A6108_0_0.woff'
          rel='application/font-woff'
        />
        <link
          href='https://bucket.gameglass.gg/fonts/3A6108_0_0.ttf'
          rel='binary/octet-stream'
        />
      </Head>

      <ClerkProvider  signInUrl={'/login'} appearance={{
        baseTheme: dark
      }} publishableKey={process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY}>


          <Provider store={store}>
            <ScreenProvider>
              <Renderer {...props} />
            </ScreenProvider>
          </Provider>
      </ClerkProvider>
    </>
  )
}

export default MyApp
